import i18n from "../../../i18n";

export interface PurchaseProduct {
  productID: string;
  name: string;
  slotCount: number;
  price: number;
  vat: number;
  type: "one-time";
}

export const product_slot_5000: PurchaseProduct = {
  productID: "5000",
  name: i18n.t("SlotProduct5000"),
  slotCount: 5000,
  price: 9200,
  vat: 920,
  type: "one-time",
};

export const product_slot_10000: PurchaseProduct = {
  productID: "10000",
  name: i18n.t("SlotProduct10000"),
  slotCount: 10000,
  price: 11900,
  vat: 1190,
  type: "one-time",
};

export const product_slot_20000: PurchaseProduct = {
  productID: "20000",
  name: i18n.t("SlotProduct20000"),
  slotCount: 20000,
  price: 19000,
  vat: 1900,
  type: "one-time",
};
